// src/models/caixas/CaixaMov.js
export class CaixaMov {
  constructor(
    id = 0,
    caixaId,
    caixaResumoId,
    caixaGrupoId,
    tipoMov,
    formaPagId,
    dataHoraMov,
    vPag,
    vRec,
    vTroco,
    historico,
    observacao,
    usuarioId,
    caixaLocal = false,
    caixa,
    caixaResumo,
    caixaGrupo,
    formaPag,
    usuario
  ) {
    this.id = id;
    this.caixaId = caixaId;
    this.caixaResumoId = caixaResumoId;
    this.caixaGrupoId = caixaGrupoId;
    this.tipoMov = tipoMov;
    this.formaPagId = formaPagId;
    this.dataHoraMov = dataHoraMov;
    this.vPag = vPag;
    this.vRec = vRec;
    this.vTroco = vTroco;
    this.historico = historico || null;
    this.observacao = observacao || null;
    this.usuarioId = usuarioId;
    this.caixaLocal = caixaLocal;
    this.caixa = caixa || null;
    this.caixaResumo = caixaResumo || null;
    this.caixaGrupo = caixaGrupo || null;
    this.formaPag = formaPag || null;
    this.usuario = usuario || null;
  }
}
